import { useEffect, useState, useRef } from "react";
import InfoBanner from "../components/Banner.jsx";
import ImageSection from "../components/Home/Solutions.jsx";
import ContactInfo from "../components/Home/ContactInfo.jsx";
import SectionBgImage from "../components/Home/SectionBgImage.jsx";
import videoBanner from "../assets/images/video_banner.mp4";
import Navbar from "../components/Navbar.jsx";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export function Home() {
  const [isIOS, setIsIOS] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "es").split("-")[0]; // "es" | "en"

  // Datos SEO desde i18n
  const title = t("seo.home.title");
  const description = t("seo.home.description");
  const keywords = t("seo.home.keywords");
  const pathByLang = t("seo.home.pathByLang", { returnObjects: true });

  const canonical =
    lang === "es"
      ? `https://www.atmnetss.com${pathByLang.es}`
      : `https://www.atmnetss.com${pathByLang.en}`;

  useEffect(() => {
    localStorage.setItem("colorFooter", "blue");
    localStorage.setItem("colorNav", "white");

    const ua = navigator.userAgent;
    const isIOSDevice =
      /iPad|iPhone|iPod/.test(ua) &&
      /Safari/.test(ua) &&
      !/CriOS/.test(ua) &&
      !/FxiOS/.test(ua);

    setIsIOS(isIOSDevice);

    if (isIOSDevice && videoRef.current) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => setIsPlaying(true))
          .catch((err) => console.log("iOS bloqueo autoplay:", err));
      }
    }
  }, []);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div>
      <Helmet>
        <html lang={lang} />

        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content="ATM Net Systems and Solutions" />
        <meta name="robots" content="index, follow" />

        {/* canonical + alternates */}
        <link rel="canonical" href={canonical} />
        <link
          rel="alternate"
          hrefLang="es"
          href={`https://www.atmnetss.com${pathByLang.es}`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`https://www.atmnetss.com${pathByLang.en}`}
        />
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://www.atmnetss.com${pathByLang.en}`}
        />

        {/* Open Graph */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        <meta
          property="og:locale"
          content={lang === "es" ? "es_ES" : "en_US"}
        />
        <meta
          property="og:locale:alternate"
          content={lang === "es" ? "en_US" : "es_ES"}
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/og-image.jpg" />
      </Helmet>

      <div className="relative">
        <video
          ref={videoRef}
          src={videoBanner}
          loop
          muted
          playsInline
          autoPlay={!isIOS}
          className="absolute w-full h-full object-cover"
          style={{ zIndex: -1 }}
        />
        {isIOS && !isPlaying && (
          <button
            onClick={handlePlay}
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-black text-3xl px-6 py-3 rounded-full z-10"
          ></button>
        )}
        <Navbar />
        <InfoBanner />
      </div>

      <ImageSection />
      <SectionBgImage />
      <ContactInfo />
    </div>
  );
}
